import { Booking, BookingCompressed } from '@jooxter/api';
import { fromISO } from '@jooxter/utils';

export const isEarlyCheckout = (booking: BookingCompressed | Booking): boolean => {
  if (!booking.checkout?.at) {
    return false;
  }

  const start = fromISO(booking.start.dateTime);
  const checkout = fromISO(booking.checkout.at);

  if (checkout.diff(start, 'minute').as('minutes') <= 1) {
    return true;
  }

  return false;
};
